import { LogzioTheme } from '@logz-pkg/enums';
import { LogzioThemeProvider } from '@logz-ui/styleguide';
import { FunctionComponent, ReactNode } from 'react';
import { ThemeProvider } from '@logz-ui/components';
import { ThemeNames } from '@logz-ui/foundations';
import { ErrorBoundary } from '../shared/ErrorBoundary/ErrorBoundary';
import ILogzioStyleguideTheme from 'components/theme';
import { useThemeInitialization } from 'ui/hooks/theme-initialization.hook';

interface IAppContent {
  name: string;
  theme?: ILogzioStyleguideTheme['logzTheme'];
  fallback: ReactNode;
  children: ReactNode;
}

export const AppContent: FunctionComponent<IAppContent> = ({ name, children, theme, fallback }) => {
  const { data: initialTheme, isLoading } = useThemeInitialization();

  if (isLoading) {
    return null;
  }

  return (
    <LogzioThemeProvider theme={theme} initialTheme={initialTheme || LogzioTheme.Light}>
      <ThemeProvider
        initialTheme={initialTheme === LogzioTheme.Dark ? ThemeNames.Dark : ThemeNames.Light}
        withGlobalStyles={false}
      >
        <ErrorBoundary errorContext={name} fallback={fallback}>
          {children}
        </ErrorBoundary>
      </ThemeProvider>
    </LogzioThemeProvider>
  );
};
